/**
 * DropdownMenuItems.jsx
 * Created by michaelbray on 6/4/18.
 */

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../../sharedComponents/icons/Icons';

const propTypes = {
    commercialAccount: PropTypes.bool,
    signOut: PropTypes.func
};

export default class DropdownMenuItems extends PureComponent {
    render() {
        // Check if commercial user
        let commercialMenuItem = null;
        if (this.props.commercialAccount) {
            commercialMenuItem = (
                <li className="rec-select-option">
                    <a
                        className="rec-select-option-button"
                        title="Commerical Account"
                        aria-label="Commercial Account"
                        href="/account/facilities">
                            Commercial Account
                            <span className="nav-mobile-menu-row-icon">
                                <Icons.IconOffer />
                            </span>
                    </a>
                </li>
            );
        }

        return (
            <ul>
                {
                !this.props.isGuest && <Fragment>
                <li className="rec-select-option">
                    <a
                        className="rec-select-option-button"
                        title="My Account"
                        href="/account/profile"
                        aria-label="My Account">
                            My Account
                        <span className="nav-mobile-menu-row-icon">
                            <Icons.IconAccountCircle alt="My Account" />
                        </span>
                    </a>
                </li>
                <li className="rec-select-option">
                    <a
                        className="rec-select-option-button"
                        title="My Reservations"
                        href="/account/reservations"
                        aria-label="My Reservations">
                            My Reservations
                        <span className="nav-mobile-menu-row-icon">
                            <Icons.IconCalendarAvailable alt="My Reservations" />
                        </span>
                    </a>
                </li>
                <li className="rec-select-option">
                    <a
                        href="/account/passes"
                        className="rec-select-option-button"
                        title="My Passes"
                        aria-label="My Passes">
                            My Passes
                        <span className="nav-mobile-menu-row-icon">
                            <Icons.IconCard alt="My Passes" />
                        </span>
                    </a>
                </li>
                <li className="rec-select-option">
                    <a
                        href="/account/favorites"
                        className="rec-select-option-button"
                        title="My Favorites"
                        aria-label="My Favorites">
                            My Favorites
                        <span className="nav-mobile-menu-row-icon">
                            <Icons.IconFavorite alt="My Favorites" />
                        </span>
                    </a>
                </li>
                </Fragment>
                }
                <li className="rec-select-option rec-menu-cart">
                    <a
                        className="rec-select-option-button"
                        title="My Cart"
                        aria-label="My Cart"
                        href="/cart"
                        type="button">
                            My Cart
                            <span className="nav-mobile-menu-row-icon">
                                <Icons.IconCart alt="My Cart" />
                            </span>
                    </a>
                </li>
                {commercialMenuItem}
                <li className="rec-select-option">
                    <button
                        className="rec-close-dropdown-button"
                        onClick={this.props.signOut}
                        aria-label="Sign Out"
                        type="button">
                        Sign Out
                    </button>
                </li>
            </ul>
        );
    }
}

DropdownMenuItems.propTypes = propTypes;
